var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label)?_c('label',{class:['sam-label', _vm.marginBottomClass, 'mt-0']},[_vm._v(_vm._s(_vm.label))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }